export default function (key, replace = {}) {
    return window.headlessTranslator.t(key, replace);
}
